import React from 'react';
import { Fade } from 'react-reveal';
import ExperienceImg from './ExperienceImg';
import ExperienceAccordion from './experienceaccordion/ExperienceAccordion';
import './ExperienceGreeting.css';

const ExperienceGreeting = () => {
  return (
    <div className='experience-main'>
      <div className='basic-experience'>
        <Fade bottom duration={2000} distance='40px'>
          <div className='experience-heading-div'>
            <div className='experience-heading-img-div'>
              <ExperienceImg />
            </div>
            <div className='experience-heading-text-div'>
              <h1 className='experience-heading-text'>Experience</h1>
              <h3 className='experience-heading-sub-text'>
                Work and Internship
              </h3>
              <p className='experience-header-detail-text subTitle'>
                Currently working as a Front-End Software Engineer, worked with a well-established company as an Associate Software
                Engineer and also worked with a startup as a Front-End Web
                Developer.  
              </p>
            </div>
          </div>
        </Fade>
      </div>
      <ExperienceAccordion />
    </div>
  );
};

export default ExperienceGreeting;
